import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors, rt) => ({
  content: {
    backgroundColor: colors.backgroundL0,
    paddingHorizontal: theme.spacing[4],
    paddingBottom: rt.insets.bottom + theme.spacing[6],
    gap: theme.spacing[7],
  },
  loadingContent: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing[4],
  },
  submittingContent: {
    flex: 1,
    // The form sizes to its content; only the spinner panel needs room
    minHeight: rt.screen.height * 0.5,
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    // _web: {
    border: 'none',
    padding: 0,
    margin: 0,
    backgroundColor: 'transparent',
    cursor: 'pointer',
    // },
  },
}));
